import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectObjects = (state: RootState) =>
  state.rootReducer.objectsStore.objects;

export const selectIsLoadingObjects = (state: RootState) =>
  state.rootReducer.objectsStore.isLoadingObjects;

export const selectIsLoadingObjectDetail = (state: RootState) =>
  state.rootReducer.objectsStore.isLoadingObjectDetail;

export const selectObjectFilters = (state: RootState) =>
  state.rootReducer.objectsStore.objectFilters;

export const selectMarkers = (state: RootState) =>
  state.rootReducer.objectsStore.markers;

export const selectSelectedObject = (state: RootState) =>
  state.rootReducer.objectsStore.selectedObject;

export const selectObjectsState = createSelector(
  selectObjects,
  selectIsLoadingObjects,
  selectIsLoadingObjectDetail,
  selectObjectFilters,
  selectMarkers,
  selectSelectedObject,
  (
    objects,
    isLoadingObjects,
    isLoadingObjectDetail,
    objectFilters,
    markers,
    selectedObject
  ) => ({
    objects,
    isLoadingObjects,
    isLoadingObjectDetail,
    objectFilters,
    markers,
    selectedObject
  })
);
